import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// Importamos JQuery
const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $

// npm i --save axios vue-axios
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

// axios.defaults.baseURL = 'https://app-remember-mm.herokuapp.com/api'
// axios.defaults.baseURL = 'http://192.168.0.70:5000/api'

var firebase = require("firebase/app");

require("firebase/auth");
require("firebase/firestore");
require("firebase/storage");
require("firebase/analytics");

var config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_PROJECT_ID+".firebaseapp.com",
  databaseURL: "https://"+process.env.VUE_APP_FIREBASE_PROJECT_ID+".firebaseio.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_PROJECT_ID+".appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
  // apiKey: "AIzaSyBsj4FDvQ5Aq3qR7nqWccu5hDefIunM1Vg",
  // authDomain: "bridge-schoolofenglish.firebaseapp.com",
  // databaseURL: "https://bridge-schoolofenglish.firebaseio.com",
  // projectId: "bridge-schoolofenglish",
  // storageBucket: "bridge-schoolofenglish.appspot.com",
  // messagingSenderId: "772774450665",
  // appId: "1:772774450665:web:f278fe40a4764281796778",
  // measurementId: "G-Z82WS6VVVC"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({}) 

firebaseApp.analytics().logEvent('notification_received');

const db = firebaseApp.firestore()
const autn = firebase.auth()
const storage = firebase.storage()
// const admin = firebase.admin()


// export default firebaseApp.firestore()

export {firebase, db, autn}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
